import React from 'react'
import {action, computed, observable, runInAction} from 'mobx';
import {toast} from 'react-toastify';
import {delay} from '../../utils/commonUtility';
import {translate} from '../../utils/localizationUtility';
import {AlertType} from '../../constants/enums';
import {getStorage} from '../../utils/storageHelper';
import {isTeacher} from "../../utils/userUtility";
import {ReactComponent as ToastLogo} from '../../assets/images/toast-logo.svg'

const duration = 5000;

const defaultOptions = {
    duration: duration
};


class AppStore {
    @observable showToast = false;
    @observable toastOptions = {};
    @observable error = null;
    @observable libraryPath = '';
    @observable studentsPath = 'activity';
    @observable homePath = isTeacher() ? 'overview' : 'lesson-plans';
    @observable practicePath = 'lessons';
    @observable isGoogleMapsLoaded = false;
    @observable hideUpgradeAlert = false;
    @observable showAccessMessage = !getStorage().getItem('musico-access-message');


    @computed get toastData() {
        return {show: this.showToast, ...this.toastOptions};
    }

    createAlert = (type = 'default', message, ignored = 5000, options) => {
        if (toast[type]) {
            toast[type](message, {...options, autoClose: duration, position: toast.POSITION.BOTTOM_LEFT, icon: <ToastLogo/>});
        } else {
            toast[AlertType.Info](message, {...options, autoClose: duration, position: toast.POSITION.BOTTOM_LEFT, icon: <ToastLogo/>});
        }

    };

    createAlertFromMessageId = (type = 'default', messageId, values, duration = 5000, options) => {
        this.createAlert(type, translate(messageId, values), duration, options);
    };

    clearAlerts = () => {
        toast.dismiss();
    };

    clearAlert = (alertId) => {
        toast.dismiss(alertId);
    };

    @action createToast = async (options) => {
        if (this.showToast) {
            await delay(500);
            this.dismissToast();
            await delay(300);
        }
        runInAction(() => {
            this.toastOptions = {...defaultOptions, ...options};
            this.showToast = true;
        });
    };

    @action dismissToast = () => {
        this.showToast = false;
    };

    @action
    setError = (error) => {
        this.error = error;
    };

    @action
    resetError = () => {
        this.error = null;
    };

    @action
    setLibraryPath = (path) => {
        this.libraryPath = path;
    };

    @action
    setPracticePath = (path) => {
        this.practicePath = path;
    };

    @action
    setStudentsPath = (path) => {
        this.studentsPath = path;
    };

    @action
    setHomePath = (path) => {
        this.homePath = path;
    };

    @action
    setIsGoogleMapsLoaded = (val) => {
        this.isGoogleMapsLoaded = val;
    };

    @action
    setHideUpgradeAlert = (val) => {
        this.hideUpgradeAlert = val;
    };

    @action
    setShowAccessMessage = (val) => {
        this.showAccessMessage = val;
    };
}

const appStore = new AppStore();
export default appStore;

